if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('.cart-summary-drawer');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      //this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          //this.addItemToCart(response);
          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.openCartDrawer();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'header'
        }
      ];
    }

    renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        // cart icon count
        document.querySelector('.header-cart__count').innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], '.header-cart__count');
        // refresh items in cart
        document.querySelector('.cart-drawer-items').innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], '.cart-drawer-items');
        // refresh subtotal row 
        document.querySelector('.subtotal-row').innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], '.subtotal-row');
        // refresh total row
        document.querySelector('.total-row').innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], '.total-row');
        // updating shipping motivator 
        document.querySelector('.shipping-motivator_wrapper').innerHTML = 
        this.getSectionInnerHTML(parsedState.sections[section.id], '.shipping-motivator_wrapper')
        this.updateShippingMotivator();
        // refresh free gift section
        document.querySelector('.free-gift__wrapper').innerHTML = 
        this.getSectionInnerHTML(parsedState.sections[section.id], '.free-gift__wrapper');
        if (jettygifts_thresholds !== undefined && jettygifts_thresholds !== false) {
          setupGifts = false;
          setupGifts = new FreeGift(jettygifts);
        }
      }));
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    // open cart drawer
    openCartDrawer() {
      // const cartSummaryDrawer = document.querySelector('.cart-summary-drawer');
      // const mainContent = document.getElementById('MainContent');

      // mainContent.classList.add('cart-open');
      // cartSummaryDrawer.classList.add('cart-open');

      // setTimeout(function() {
      //   mainContent.classList.remove('cart-open');
      //   cartSummaryDrawer.classList.remove('cart-open');
      // }, 3000);
    }

    updateShippingMotivator() {
      // free shipping motivator script
      var motivatorLine = document.querySelector('.shipping-motivator_line-fill')
      var motivatorLineContainer = document.querySelector('.shipping-motivator_line');

      var freeShippingThreshold = document.querySelector('.shipping-motivator').dataset.shippingthreshold;
      var cartTotal = document.querySelector('.shipping-motivator').dataset.carttotal;
      var fillPercentage = cartTotal / freeShippingThreshold;
      var amountRemaining = freeShippingThreshold - cartTotal;
  
      console.log(cartTotal);
  
      if ( fillPercentage < 1 ) {
        motivatorLine.style.right = ((1-fillPercentage) * 100) + '%';
        var amountRemaining = (freeShippingThreshold - cartTotal).toFixed(2);
        document.querySelector('.shipping-motivator_amount').innerHTML = amountRemaining;
      } else {
        motivatorLineContainer.style.display = 'none';
        motivatorLine.style.right = 0 + '%';
        document.querySelector('.shipping-motivator_text').innerHTML = "You've qualified for free shipping!";
      }
    }

  });
}
